import analytics from '..';

async function trackAutofillEvent(fieldId, fieldName) {
  const autofillPayload = {
    field_id:   fieldId,
    field_name: fieldName,
  };
  await analytics.track('autofill', autofillPayload);
}

function handleChangeEvent(e) {
  const { target } = e;
  const fieldId = target.id;
  const fieldName = target.name;
  const { autocompleted } = target.dataset;
  delete target.dataset.autocompleted;

  if (!autocompleted || autocompleted !== '1') {
    target.removeEventListener('change', handleChangeEvent);
    return;
  }

  target.removeEventListener('change', handleChangeEvent);
  trackAutofillEvent(fieldId, fieldName);
}

function handleAnimationEvent(e) {
  const { target } = e;

  if (e.animationName === 'onAutoFillStart') {
    target.dataset.autocompleted = '1';
  } else if (e.animationName === 'onAutoFillCancel') {
    target.dataset.autocompleted = '0';
  }

  target.addEventListener('change', handleChangeEvent);
}

function addAutofillEventListener() {
  document.addEventListener('animationstart', handleAnimationEvent);
}

function removeAutofillEventListener() {
  document.removeEventListener('animationstart', handleAnimationEvent);
}

export {
  addAutofillEventListener,
  removeAutofillEventListener,
  trackAutofillEvent,
  handleAnimationEvent,
  handleChangeEvent,
};
